<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/19QDdHE/tc-custom/9781504037181.jpg?1705807343890" alt="This image is the cover for the book Murder Under the Palms, The Charlotte Graham Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Murder Under the Palms, The Charlotte Graham Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>Among the senior citizens of Palm Beach, legendary Oscar-winning actress Charlotte Graham finds love, murder, and a delightful cozy mystery</b><br/><br/> After fifty years on stage and screen, Hollywood icon Charlotte Graham has gone south for the winter. In the glamorous confines of Palm Beach, Charlotte sips rum cocktails, reunites with friends, and rekindles the flame with a former lover. Eddie Norwood was a legendary conductor of the big-band era, and the man who stole Charlotte’s heart aboard the SS <i>Normandie</i>, a fabulously opulent ocean liner that was sabotaged in 1942. Charlotte and Eddie reconnect at a party to honor the memory of the <i>Normandie</i>, and the old sparks are just beginning to fly when their reunion is interrupted by murder.<br/>  <br/> A jewelry designer has been found dead on the beach, and only Charlotte has the poise, wit, and old Hollywood charm necessary to find the killer—and perhaps a little love along the way.<br/>  <br/> Fans of Conrad Allen’s nautical mysteries will be enchanted by Stefanie Matteson’s ability to recreate the glory days of the old ocean liners. Whether sipping champagne or investigating a murder, Charlotte Graham proves that true glamour stands the test of time.<br/>  <br/><i>Murder Under the Palms</i> is the 8th book in the Charlotte Graham Mysteries, but you may enjoy reading the series in any order.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stefanie Matteson
      </h2>
      
      <p class="authorDescription body article">Stefanie Matteson is a novelist, journalist, and publicist. After graduating from Skidmore College with a degree in chemistry, Matteson worked as an editor and reporter, winning awards for her coverage of the sciences. In 1990, she published <I>Murder at the Spa</I>, which introduced the sleuthing Hollywood legend Charlotte Graham, whom Matteson would follow through seven more novels, including <I>Murder on the Silk Road</I> (1992) and <I>Murder on High</I> (1994).</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5d201974